<template>
  <div class="sky-server-config">
    <div class="wsp-display-flex wsp-line-height-28 wsp-padding-top-3">
      <div class="wsp-width-90 wsp-text-align-left ">
        <span
          ><label class="wsp-label">1.</label>
          测试准备阶段:售后入场测试后，登录平台根据现场实际情况在线更新售前测试方案
        </span>
      </div>
    </div>
    <div class="wsp-display-flex wsp-line-height-28 wsp-padding-top-3 wsp-padding-left-24">
      <div class="wsp-width-90 wsp-text-align-left">
        <span
          ><label class="wsp-label">a.</label
          >操作步骤:点击"售前测试"--"我的项目"--找到售前对应的测试项目一一点击"处理"--点击"上一步"一点击右上角的模块根据实际情况修改后进行保存。
          保存后一直点击"下一步"生成测试方案。
        </span>
      </div>
    </div>
    <div class="wsp-display-flex wsp-line-height-28 wsp-padding-top-3 wsp-padding-left-48">
      <div class="wsp-width-90 wsp-text-align-left ">
        <span
          ><label class="wsp-label">i.</label
          >下载word作为"测试方案终稿"上传到CSM系统：点击"下载word"--上传到CSM系统测试准备阶段的"上传测试方案终稿"</span
        >
      </div>
    </div>
    <div class="wsp-display-flex wsp-line-height-28 wsp-padding-top-3 wsp-padding-left-48">
      <div class="wsp-width-90 wsp-text-align-left ">
        <span
          ><label class="wsp-label">ii.</label
          >下载excel作为"测试执行管理表初稿"上传到CSM系统：点击"下载excel"--上传到CSM系统测试准备阶段的的"上传测试执行管理表初稿"
        </span>
      </div>
    </div>

    <div class="wsp-display-flex wsp-line-height-28">
      <div class="wsp-width-90 wsp-text-align-left ">
        <span><label class="wsp-label">2.</label>项目关闭阶段:售后测试完成阶段</span>
      </div>
    </div>
    <div class="wsp-display-flex wsp-line-height-28 wsp-padding-top-3 wsp-padding-left-24">
      <div class="wsp-width-90 wsp-text-align-left ">
        <span><label class="wsp-label">a.</label>操作步骤: </span>
      </div>
    </div>
    <div class="wsp-display-flex wsp-line-height-28 wsp-padding-top-3 wsp-padding-left-48">
      <div class="wsp-width-90 wsp-text-align-left ">
        <span
          ><label class="wsp-label">i.</label>
          根据首次下载的测试执行管理表最后2个sheet更新项目中遇到的问题和需求。上传到CSM系统项目关闭阶段
          的"是否上传测试执行管理表终稿(仅云桌面测试需上传)"
        </span>
      </div>
    </div>
    <div class="wsp-display-flex wsp-line-height-28 wsp-padding-top-3 wsp-padding-left-48">
      <div class="wsp-width-90 wsp-text-align-left ">
        <span>
          <label class="wsp-label">ii.</label>
          根据测试方案初稿或在线测试方案补充和完善测试步骤和测试结果CSM系统项目关闭阶段的"测试报告上传"
        </span>
      </div>
    </div>
    <div class="wsp-display-flex wsp-line-height-28">
      <div class="wsp-width-90 wsp-text-align-left ">
        <span>
          详细操作查看：
          <a href="https://ruijie.feishu.cn/wiki/Acx8wp3PpiKoPAkTBMocVmsfnAb" target="_blank">
            售前测试SOP上CSM操作指导
          </a>
        </span>
      </div>
    </div>

    <div style="text-align: center; margin-top: 10px;">
      <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="onCancel">
        确定
      </el-button>
    </div>
  </div>
</template>
<script type="text/babel">
import { Input, Button, RadioButton, RadioGroup } from 'element-ui'

import lang from '@/lang'
export default {
  name: 'SkyCsmGuideDialog',
  inject: ['rootView', 'elForm'],
  components: {
    [Input.name]: Input,
    [RadioButton.name]: RadioButton,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup
  },
  props: {},
  data() {
    return {
      lang: lang
    }
  },
  mounted() {},
  watch: {},
  methods: {
    onCancel() {
      this.$emit('cb')
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(server-config) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(mutiple-select) {
    width: 300px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
